import type { Intersection, SignalDef } from './types';

export type SignalColour = 'green' | 'amber' | 'red';

export interface SignalState {
  phaseIndex: number;
  /** Seconds into the current phase. */
  t: number;
  /** Seconds until the phase changes. */
  remaining: number;
}

export function cycleLength(sig: SignalDef): number {
  let total = 0;
  for (const p of sig.phases) total += p.duration;
  return total;
}

/** Deterministic signal state for simulation time `time` (seconds). */
export function signalStateAt(sig: SignalDef, time: number): SignalState {
  const len = cycleLength(sig);
  if (len <= 0) return { phaseIndex: 0, t: 0, remaining: Infinity };
  let t = (time + sig.offset) % len;
  if (t < 0) t += len;
  for (let i = 0; i < sig.phases.length; i++) {
    const d = sig.phases[i]!.duration;
    if (t < d) return { phaseIndex: i, t, remaining: d - t };
    t -= d;
  }
  return { phaseIndex: sig.phases.length - 1, t: 0, remaining: 0 };
}

/** Colour shown to traffic approaching `intersection` along `edgeId`. Unsignalled -> 'green'. */
export function signalColourFor(intersection: Intersection, edgeId: number, time: number): SignalColour {
  const sig = intersection.signal;
  if (!sig) return 'green';
  const st = signalStateAt(sig, time);
  const phase = sig.phases[st.phaseIndex]!;
  if (phase.green.includes(edgeId)) return 'green';
  if (phase.amber.includes(edgeId)) return 'amber';
  return 'red';
}
